import React from 'react';
import styled from 'styled-components/macro';
import * as colors from 'src/styles/colors';
import { PrimaryColors } from 'src/types/globalTypes';
import { rowComponents } from 'src/utils/indexs';
import TmarkClassTag from 'src/components/layout/tag/TmarkClassTag';
import { IResTmarkRights } from 'src/types/api/trademarkRightsApiTypes';

// 輸出共用項目
export const Wrapper = styled.div<{ color: string }>`
  display: block;
  border: 1px solid ${(prop) => prop.color};
  border-radius: 8px;
  margin: 0 1em;
`;
export const Card = styled.div<{ color: string }>`
  display: grid;
  gap: 0.5em;
  border-bottom: 1px solid ${(prop) => prop.color};
  padding: 24px 32px;
  :last-child {
    border-bottom: none;
  }
`;
export const MobileContent = styled.div`
  font-family: NotoSansTC-Medium;
  display: grid;
  gap: 12px;
  line-height: 1.5em;
`;
export const MobileItem = styled.div`
  display: flex;
  text-align: left;
`;
export const MobileTitle = styled.span`
  color: ${colors.BlueGray_500};
  white-space: nowrap;
`;
export const MobileItemContent = styled.span`
  word-break: break-word;
`;

// 非共用
const Img = styled.img`
  height: 72px;
  box-shadow: 5px 5px 11px rgba(67, 67, 67, 0.2);
`;
const ImgDiv = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 16px 0;
`;

interface IProps {
  data: IResTmarkRights[];
  colorType: PrimaryColors;
  handleOnClick: (applNo: string, applyClass: string) => void;
}

const TmarkResultMobile: React.FC<IProps> = ({ data, colorType, handleOnClick }) => {
  const borderColor = colorType.third;
  const linkColor = colorType.seventh;

  // 表格常數
  const SEPRATOR = '，'; //名稱間隔
  
  const handleKeyDown = (
    e: React.KeyboardEvent<HTMLElement>, 
    callback: () => void
  ): void => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      callback();
    }
  };

  return (
    <Wrapper color={borderColor}>
      {data.map((item, index) => {
        index += 1;
        return (
          <Card key={index} color={borderColor}>
            <MobileContent>
              <ImgDiv>
                <Img src={item.tmarkImageUrl} alt="" />
              </ImgDiv>
              <MobileItem>
                <TmarkClassTag type={item.tmarkClass} />
              </MobileItem>
              <MobileItem>
                <MobileTitle>註冊號數：</MobileTitle>
                <MobileItemContent>{item.examNo}</MobileItemContent>
              </MobileItem>
              <MobileItem>
                <MobileTitle>商標權人：</MobileTitle>
                <MobileItemContent>{rowComponents(item.holdersNameC, SEPRATOR)}</MobileItemContent>
              </MobileItem>
              <MobileItem>
                <MobileTitle>商標名稱：</MobileTitle>
                <MobileItemContent
                  style={{ color: linkColor, cursor: 'pointer' }}
                  onClick={() => handleOnClick(item.examNo, item.tmarkClass)}
				  tabIndex={0}
				  role="button"
				  onKeyDown={(e) => handleKeyDown(e, () => handleOnClick(item.examNo, item.tmarkClass))}
                >
                  {item.tmarkName}
                </MobileItemContent>
              </MobileItem>
              <MobileItem>
                <MobileTitle>權利期間：</MobileTitle>
                <MobileItemContent>
                  {item.regDate}~{item.deadlineDate}
                </MobileItemContent>
              </MobileItem>
            </MobileContent>
          </Card>
        );
      })}
    </Wrapper>
  );
};

export default TmarkResultMobile;
